import { HrmIncomeTaxTableDto, defaultHrmIncomeTaxTableDto } from "src/dtos/hrmIncomeTaxTable/hrmIncomeTaxTableDto";
/** 연도 전체 교체 요청이다. */
export interface HRM3130_R01Dto {
    applyYear: string; // 저장 연도
    hrmIncomeTaxTableDtoList: HRM3130_R01TaxTableDto[]; // 저장 후 남길 전체 행
}
/** 엔티티를 상속한 그리드 행이다. */
export interface HRM3130_R01TaxTableDto extends HrmIncomeTaxTableDto {}
/** 저장된 표를 사용한 서버 계산 응답이다. */
export interface HRM3130_R01TaxDto {
    applyYear: string; // 실제 사용 연도
    taxableAmt: number; // 월 과세급여
    familyCount: number; // 보정된 가족수
    fromAmt: number | null; // 시작 금액, 최저 미만이면 null
    toAmt: number | null; // 끝 금액, 최저 미만이면 null
    incomeTax: number; // 소득세
    localIncomeTax: number; // 지방소득세
}
/** 서버 공용 가산 산식 한 구간이다. */
export interface HRM3130_R01SurchargeRuleDto {
    overAmt: number; // 초과 기준 금액
    addAmt: number; // 고정 가산액
    isApplyNinetyEightPercent: boolean; // true이면 초과액에 98% 적용
    taxRate: number; // 세율
}
/** 엔티티 기본값을 복사한 화면 행 기본값이다. */
export const defaultHRM3130_R01TaxTableDto: HRM3130_R01TaxTableDto = { ...defaultHrmIncomeTaxTableDto };
/** 저장 요청 초기값이다. */
export const defaultHRM3130_R01Dto: HRM3130_R01Dto = { applyYear: '', hrmIncomeTaxTableDtoList: [] };
